import esContent from './usePaymentModal.es';

export default {
  ...esContent,
};
